import React from 'react';
import PropTypes from "prop-types";

class Popup extends React.Component {

  static propTypes = {
    closePopup: PropTypes.func
  };

  render() {
    return (
      <div className='popup'>
        <div className='popup_inner'>
          <p><br/><br/>Liebe/r Nutzer/in,
            <br/><br/>
            wir haben unsere <a href="https://www.media4care.de/agb/" target="_blank">Allgemeinen Geschäftsbedingungen</a> sowie unsere <a href="https://www.media4care.de/datenschutz/"  target="_blank">Datenschutzrichtlinien</a> für mehr Transparenz angepasst.
            <br/><br/>
            Bitte nehmen Sie sich einen kurzen Moment Zeit, um diese zu lesen.
            <br/><br/>
            Mit dem Tippen auf OK fahren Sie fort und erklären sich mit diesen einverstanden.
            <br/><br/></p>
            <button className="buttonEula" onClick={this.props.closePopup}>OK</button>
        </div>
      </div>
    );
  }
}

export default Popup;
